"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const pixi_js_1 = require("pixi.js");
const pixi_1 = require("./pixi");
/*
 * MODELS
 */
class Walker extends pixi_js_1.Point {
    step() {
        const delta_x = Math.random() * 3 - 1.5;
        const delta_y = Math.random() * 3 - 1.5;
        this.x += delta_x;
        this.y += delta_y;
    }
}
/*
 * CONTROLLER
 */
const draw = new pixi_js_1.Graphics();
pixi_1.pixiApp.stage.addChild(draw);
draw.lineStyle(2, 0x000000, 1);
const walker = new Walker(pixi_1.pixiApp.renderer.width / 2, pixi_1.pixiApp.renderer.height / 2);
draw.moveTo(walker.x, walker.y);
pixi_1.pixiApp.ticker.speed = 2;
pixi_1.pixiApp.ticker.add(() => {
    draw.moveTo(walker.x, walker.y);
    walker.step();
    draw.lineTo(walker.x, walker.y);
});
